module.exports = __webpack_public_path__ + "static/media/golfer-5-b.6c89432a.png";